import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link
          to="/"
          className={`flex items-center gap-2 font-heading text-xl font-bold whitespace-nowrap cursor-pointer ${
            scrolled || !isHome ? 'text-foreground-950' : 'text-white'
          }`}
        >
          <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-white text-sm font-bold">
            拍
          </span>
          <span>拍得好</span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-3 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                scrolled || !isHome
                  ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                  : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-3 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
              scrolled || !isHome
                ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                : 'text-white/80 hover:text-white hover:bg-white/10'
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer ${
            scrolled || !isHome ? 'text-foreground-950' : 'text-white'
          }`}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 shadow-lg">
          <div className="px-4 py-3 flex flex-col gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-3 py-2.5 text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 rounded-lg cursor-pointer whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-3 py-2.5 text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 rounded-lg cursor-pointer whitespace-nowrap"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}